import { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { dadosIntegracaoAsaasResposta } from '../../interfaces/asaas'
import { statusIntegracaoResposta } from '../../interfaces/inter'
import { dadosIntegracaoWaResposta } from '../../interfaces/wa'
import { buscarIntegracao } from '../../services/asaas'
import { statusIntegracao } from '../../services/inter'
import { atualizarIntegracaoWa, dadosWa, sincronizarModelosWa } from '../../services/wa'
import { Button } from '../Styles'
import asaasImg from '../../assets/img/asaas.png'
import bancoInteterImg from '../../assets/img/bancoInter.png'
import whatsAppImg from '../../assets/img/whatsappCobranca.png'
import Permissoes from '../../middleware/Permissoes'
import DivSituacao from '../DivSituacao'
import ModalIntegracaoAsaas from '../ModalAsaas'
import ModalIntegracaoInter from '../ModalIntegracaoInter'
import ModalIntegracaoWhatsapp from '../ModalIntegracaoWhatsapp'
import ToogleDefault from '../ToogleDafault'
import './integracoes.css'
import { descriptografarDado } from '../../helpers'

function Integracoes() {

    const { modalEstado, exibirModal, atualizarInformacoes, atualizarDados } = useContext(ModalEstadoContext)

    const { modal, modalExibir } = useContext(ModalEstadoContext)

    const [asaas, setAsaas] = useState<dadosIntegracaoAsaasResposta>()
    const [dadosIntegracao, setDadosIntegracao] = useState<statusIntegracaoResposta>()
    const [dadosIntegracaoWa, setDadosIntegracaoWa] = useState<dadosIntegracaoWaResposta>()
    const [modalInter, setModalInter] = useState(false)
    const [processando, setProcessando] = useState(false)

    const exibirModaltarefas = () => exibirModal()
    const exibirModalIntegracaoWhatsApp = () => modalExibir('integracaoWa')
    const exibirModalAsaas = () => modalExibir('asaas')

    const atualizarSessao = async () => {

        try {
            const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
            const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_integracao']
            const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

            if(!temPermissao) return toast.warn("Você não tem permissão para sincronizar um modelo.")
            setProcessando(true)

            const resposta = await toast.promise(
                atualizarIntegracaoWa(), {
                pending: 'Processsando a sua Solicitação'
            })

            if (resposta.status === 200) {
                toast.success("Sessão do WhatsApp Atualizada com Sucesso")
                atualizarDados()
                return
            }

        } catch (error: any) {

            if (error.response.status === 200) {
                toast.error("Sessão não encontrada.")
                return
            }
            toast.error('Falha ao tentar Atualizar a Sessão de WhatsApp')

            return

        } finally {
            setProcessando(false)
        }
    }

    const sincronizarModelos = async () => {
        try {
            const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
            const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_integracao']
            const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

            if(!temPermissao) return toast.warn("Você não tem permissão para sincronizar os modelos.")
            setProcessando(true)

            const resposta = await sincronizarModelosWa()

            if (resposta.status === 200) {
                toast.success("Modelos Sincronizados com Sucesso.")
                atualizarDados()
                return true
            }
        } catch (error) {

            toast.error('Falha ao tentar Sincronizar os Modelos.')
            return

        } finally {
            setProcessando(false)
        }
    }

    useEffect(() => {
        setModalInter(modalEstado)
    }, [modalEstado])

    useEffect(() => {
        const buscarDadosIntegracaoWa = async () => {

            try {

                const resposta = await toast.promise(
                    dadosWa(), {
                    pending: 'Buscando Dados da Integração com o WhatsApp'
                }
                )

                if (resposta.status === 200 && resposta.data) {
                    setDadosIntegracaoWa({
                        nomeSessao: resposta.data.sessao,
                        situacao: resposta.data.situacao
                    })
                }

            } catch (error) {
                toast.error('Falha ao Buscar dos Dados da Integração com o WhatsApp')
                return

            }
        }

        buscarDadosIntegracaoWa()

    }, [atualizarInformacoes])

    useEffect(() => {

        const buscarDadosIntegracao = async () => {

            try {

                const resposta = await toast.promise(
                    statusIntegracao(), {
                    pending: 'Buscando dados da Integração com o Inter',
                }
                )
                if (resposta.status === 200) {
                    setDadosIntegracao(resposta.data)
                }

            } catch (error) {

                toast.error('Falha ao Buscar os Dados da Integração com o Inter')

                return
            }
        }

        buscarDadosIntegracao()

    }, [atualizarInformacoes])

    useEffect(() => {

        const buscarDadosIntegracaoAsaas = async () => {

            try {

                const resposta = await toast.promise(
                    buscarIntegracao(),
                    {
                        pending: 'Buscando dados da Integração Asaas',
                    }
                )

                if (resposta.status === 200) {
                    setAsaas(resposta.data)
                }

            } catch (error) {

                toast.error('Falha ao Buscar os Dados da Integração com o Asaas')

                return
            }
        }

        buscarDadosIntegracaoAsaas()

    }, [atualizarInformacoes])

    return (
        <Permissoes permissoes={['master', 'administrativo', 'configuracao_integracao']}>
            <div id='paginaIntegracoes'>
                {modalInter && <ModalIntegracaoInter dadosIntegracaoInter={dadosIntegracao} />}
                {modal.nome === 'integracaoWa' && <ModalIntegracaoWhatsapp />}
                {modal.nome === 'asaas' && <ModalIntegracaoAsaas dados={asaas} />}
                <section className='tituloIntegracaoContainer'>
                    <h1>Integrações Disponíveis</h1>
                </section>
                <div className='integracoesContainer'>
                    <section className='cardIntegracoesContainer' onClick={exibirModaltarefas}>
                        <span className='cardIntegracao'>
                            <img className='cardIntegracaoIcone' src={bancoInteterImg} alt='' />
                            <p>Gere cobranças automaticamente com o Banco Inter</p>
                            {dadosIntegracao?.validade && <p>Validade: <b>{dadosIntegracao?.validade?.slice(8, 10)}/{dadosIntegracao.validade?.slice(5, 7)}/{dadosIntegracao.validade?.slice(0, 4)}</b></p>}
                            {dadosIntegracao && <span className='situacaoIntegracao'>
                                <DivSituacao texto={dadosIntegracao.situacao.charAt(0).toUpperCase() + dadosIntegracao.situacao.substring(1)} cor={dadosIntegracao.situacao?.toLowerCase()} />
                            </span>}
                        </span>
                    </section>
                    <section className='cardIntegracoesContainer'>
                        <span className='cardIntegracao'>
                            <img className='cardIntegracaoIcone' src={whatsAppImg} alt=''  onClick={exibirModalIntegracaoWhatsApp}/>
                            <p>Conecte seu WhatsApp e envie cobranças e avisos automáticos</p>
                            {dadosIntegracaoWa?.situacao && <span className='situacaoIntegracao'>
                                <DivSituacao texto={dadosIntegracaoWa.situacao} cor={dadosIntegracaoWa.situacao.toLowerCase()} />
                            </span>}
                            <div className='contentOpcoesIntegracoesWhatsApp'>
                                {!dadosIntegracaoWa && <Button type='button' cor='solicitarUsuario' isLoading={processando} onClick={exibirModalIntegracaoWhatsApp}>Conectar WhatsApp</Button>}
                                <span>
                                    {dadosIntegracaoWa?.situacao === "Conectado" && <Button type='button' cor='solicitarUsuario' isLoading={processando} onClick={sincronizarModelos}>Sincronizar Modelos</Button>}
                                </span>
                                {dadosIntegracaoWa &&
                                    <span>
                                        <ToogleDefault id={dadosIntegracaoWa.nomeSessao} checked={() => dadosIntegracaoWa?.situacao === 'Conectado' ? true : false} onClick={atualizarSessao}/>
                                    </span>
                                }
                                
                            </div>
                        </span>
                    </section>
                    <section className='cardIntegracoesContainer' onClick={exibirModalAsaas}>
                        <span className='cardIntegracao'>
                            <img className='cardIntegracaoIcone' src={asaasImg} alt='' />
                            <p>Gere Cobranças com Cartão de Crédito e Débito com sua conta Asaas</p>
                            {asaas && <span className='situacaoIntegracao'>
                                <DivSituacao texto={asaas !== undefined ? asaas.situacao : ''} cor={asaas !== undefined ? asaas.situacao.toLowerCase() : ''} />
                            </span>}
                        </span>
                    </section>
                </div>
            </div>
        </Permissoes>
    )
}

export default Integracoes